<template>
  <div class="form2-container">
    <div class="section-header">
      <h2 class="section-title">关卡设计与谜题配置</h2>
      <span class="section-tip"
        >设计本关的目标题目、线索图与玩法类型，右侧实时同步 App 体验效果</span
      >
    </div>

    <div class="editor-layout">
      <!-- 左侧：表单编辑区 -->
      <div class="form-area">
        <el-form
          :model="form"
          label-width="auto"
          label-position="top"
          :rules="rules"
          ref="ruleForm"
          status-icon
          class="custom-form"
        >
          <el-form-item label="关卡标题" prop="levelTitle">
            <el-input
              v-model="form.levelTitle"
              placeholder="例如：古戏台的机关锁"
              clearable
            />
          </el-form-item>

          <el-form-item label="关卡难度" prop="difficulty">
            <div class="rate-box">
              <el-rate v-model="form.difficulty" size="large" />
              <span class="rate-tip">{{ difficultyText }}</span>
            </div>
          </el-form-item>

          <el-form-item label="角色专属提示" prop="selectRole">
            <el-select
              v-model="selectRole2"
              placeholder="选择适用的角色"
              multiple
              @change="valueChange"
              style="width: 100%"
            >
              <el-option
                v-for="item in roleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-alert
              title="提示：可使用句号「。」作为不同角色线索的分隔标识"
              type="info"
              :closable="false"
              class="role-alert"
            />
            <el-input
              v-model="form.roleTip"
              type="textarea"
              :rows="4"
              placeholder="侦探角色提示。&#10;学者角色提示。"
              maxlength="500"
              show-word-limit
            />
          </el-form-item>

          <el-form-item label="题目类型" prop="region">
            <el-radio-group v-model="form.region" class="type-radio-group">
              <el-radio-button value="填空题">填空题</el-radio-button>
              <el-radio-button value="选择题">选择题</el-radio-button>
              <el-radio-button value="AR题">AR 互动题</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <!-- ================= 填空题分支 ================= -->
          <div v-if="form.region === '填空题'" class="question-branch">
            <el-form-item label="谜题正文描述" prop="levelContent">
              <el-input
                v-model="form.levelContent"
                type="textarea"
                :rows="6"
                maxlength="800"
                show-word-limit
                placeholder="请输入玩家需要阅读并解答的线索正文..."
              />
            </el-form-item>

            <el-form-item label="谜题线索参考图" prop="levelCover">
              <div class="single-uploader-card">
                <el-upload
                  class="uploader-box"
                  :action="UpdateApi"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  :disabled="allowUpload"
                >
                  <div v-if="form.levelCover" class="img-preview-box">
                    <el-image
                      :src="form.levelCover"
                      class="img-content"
                      fit="cover"
                    />
                    <div class="hover-mask">
                      <span
                        class="del-btn"
                        @click.stop="clearImage('levelCover')"
                        title="删除图片"
                      >
                        <el-icon><Delete /></el-icon>
                      </span>
                    </div>
                  </div>
                  <div v-else class="upload-trigger">
                    <el-icon class="icon"><Plus /></el-icon>
                    <span class="text">上传线索图</span>
                    <span class="text">支持 4:3 | 1:1 | 3:4 / 小于 5MB</span>
                  </div>
                </el-upload>
              </div>
            </el-form-item>

            <el-form-item
              label="标准答案设定（区分大小写或多答案关键词）"
              prop="levelDesc"
            >
              <el-input
                v-model="form.levelDesc"
                type="textarea"
                :rows="3"
                maxlength="400"
                show-word-limit
                placeholder="输入正确答案，玩家输入一致方可通关"
              />
            </el-form-item>
          </div>

          <!-- ================= 选择题分支 ================= -->
          <div v-if="form.region === '选择题'" class="question-branch">
            <el-alert
              title="规则说明"
              type="warning"
              description="每道题目至少添加 2 个选项，并点击右侧单选框标记正确答案。"
              :closable="false"
              class="role-alert"
            />

            <div
              v-for="(domain, dIndex) in domains"
              :key="domain.key"
              class="choice-card"
            >
              <div class="choice-card-header">
                <span class="title">第 {{ dIndex + 1 }} 题</span>
                <el-button
                  type="danger"
                  link
                  size="small"
                  @click="removeDomain(domain)"
                >
                  删除题目
                </el-button>
              </div>

              <el-form-item label="题目题干">
                <el-input
                  v-model="domain.value"
                  placeholder="请输入问题描述..."
                />
              </el-form-item>

              <div class="options-container">
                <span class="opt-label">选项配置（选中即为正确答案）</span>
                <el-radio-group
                  v-model="domain.rightAnswer"
                  class="opt-radio-group"
                >
                  <div
                    class="option-row"
                    v-for="(opt, oIndex) in domain.options"
                    :key="opt.id || oIndex"
                  >
                    <el-radio :value="opt.one" class="opt-radio" />
                    <el-input
                      v-model="opt.one"
                      placeholder="选项文字描述"
                      class="opt-input"
                    />
                    <el-button
                      type="danger"
                      link
                      :icon="Delete"
                      class="opt-del-btn"
                      @click="deleteOption(domain, oIndex)"
                    />
                  </div>
                </el-radio-group>

                <div class="opt-footer-actions">
                  <el-button
                    type="primary"
                    plain
                    size="small"
                    :icon="Plus"
                    @click="addOption(domain)"
                    :disabled="domain.options && domain.options.length >= 4"
                  >
                    增加选项 ({{
                      domain.options ? domain.options.length : 0
                    }}/4)
                  </el-button>
                </div>
              </div>
            </div>

            <div class="choice-actions">
              <el-button
                type="primary"
                :icon="Plus"
                @click="addDomain"
                :disabled="domains.length >= 4"
              >
                添加一道选择题 ({{ domains.length }}/4)
              </el-button>
              <el-button @click="resetForm">清空全部题目</el-button>
            </div>
          </div>

          <!-- ================= AR 题分支 ================= -->
          <div v-if="form.region === 'AR题'" class="question-branch">
            <el-form-item label="AR 谜题指引说明" prop="arQuestion">
              <el-input
                v-model="form.arQuestion"
                type="textarea"
                :rows="5"
                maxlength="500"
                show-word-limit
                placeholder="引导玩家使用手机扫描实物目标的说明..."
              />
            </el-form-item>

            <div class="ar-uploaders-row">
              <el-form-item
                label="目标识别图（现实物体/海报）"
                class="ar-upload-item"
              >
                <div class="single-uploader-card">
                  <el-upload
                    class="uploader-box"
                    :action="UpdateApi"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess2"
                    :before-upload="beforeAvatarUpload"
                    :disabled="allowUpload2"
                  >
                    <div v-if="form.arImageRecognition" class="img-preview-box">
                      <el-image
                        :src="form.arImageRecognition"
                        class="img-content"
                        fit="cover"
                      />
                      <div class="hover-mask">
                        <span
                          class="del-btn"
                          @click.stop="clearImage('arImageRecognition')"
                          title="删除图片"
                        >
                          <el-icon><Delete /></el-icon>
                        </span>
                      </div>
                    </div>
                    <div v-else class="upload-trigger">
                      <el-icon class="icon"><Plus /></el-icon>
                      <span class="text">上传识别图</span>
                      <span class="text">支持 4:3 | 1:1 | 3:4 / 小于 5MB</span>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>

              <el-form-item
                label="AR 触发显示内容（叠加图）"
                class="ar-upload-item"
              >
                <div class="single-uploader-card">
                  <el-upload
                    class="uploader-box"
                    :action="UpdateApi"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess3"
                    :before-upload="beforeAvatarUpload"
                    :disabled="allowUpload3"
                  >
                    <div v-if="form.arImageContent" class="img-preview-box">
                      <el-image
                        :src="form.arImageContent"
                        class="img-content"
                        fit="cover"
                      />
                      <div class="hover-mask">
                        <span
                          class="del-btn"
                          @click.stop="clearImage('arImageContent')"
                          title="删除图片"
                        >
                          <el-icon><Delete /></el-icon>
                        </span>
                      </div>
                    </div>
                    <div v-else class="upload-trigger">
                      <el-icon class="icon"><Plus /></el-icon>
                      <span class="text">上传内容图</span>
                      <span class="text">支持 4:3 | 1:1 | 3:4 / 小于 5MB</span>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>

              <el-form-item
                label="AR 触发显示内容（返回图）"
                class="ar-upload-item"
              >
                <div class="single-uploader-card">
                  <el-upload
                    class="uploader-box"
                    :action="UpdateApi"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess4"
                    :before-upload="beforeAvatarUpload"
                    :disabled="allowUpload4"
                  >
                    <div v-if="form.arImageBack" class="img-preview-box">
                      <el-image
                        :src="form.arImageBack"
                        class="img-content"
                        fit="cover"
                      />
                      <div class="hover-mask">
                        <span
                          class="del-btn"
                          @click.stop="clearImage('arImageBack')"
                          title="删除图片"
                        >
                          <el-icon><Delete /></el-icon>
                        </span>
                      </div>
                    </div>
                    <div v-else class="upload-trigger">
                      <el-icon class="icon"><Plus /></el-icon>
                      <span class="text">上传内容图</span>
                      <span class="text">支持 4:3 | 1:1 | 3:4 / 小于 5MB</span>
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>

      <!-- 右侧：统一移动端拟物真机视口 -->
      <div class="preview-area">
        <div class="preview-header">
          <span class="badge-dot"></span>
          <span>{{ form.region }} · 移动端交互视口</span>
        </div>

        <div class="mockup-phone">
          <div class="phone-top-bar">
            <div class="notch"></div>
          </div>

          <!-- 填空题真机预览 -->
          <div class="phone-screen" v-if="form.region === '填空题'">
            <div class="mock-nav">
              <el-icon><ArrowLeft /></el-icon>
              <span class="nav-title">{{ form.levelTitle || "关卡详情" }}</span>
              <el-icon><QuestionFilled /></el-icon>
            </div>

            <div class="screen-scrollable">
              <div class="mock-sub-row">
                <div class="diff-tag">
                  难度
                  <el-rate v-model="form.difficulty" disabled size="small" />
                </div>
                <span class="recall-btn">故事线索</span>
              </div>

              <div class="mock-body-text">
                {{ form.levelContent || "这里展示谜题具体内容与逻辑提示..." }}
              </div>

              <div class="mock-clue-card" v-if="form.levelCover">
                <span class="clue-tag">关联线索</span>
                <el-image :src="form.levelCover" fit="cover" class="clue-img" />
              </div>
            </div>

            <div class="screen-footer">
              <div class="mock-input-mock">输入你的答案...</div>
              <button class="mock-submit-btn">验证答案</button>
            </div>
          </div>

          <!-- 选择题真机预览 -->
          <div class="phone-screen" v-else-if="form.region === '选择题'">
            <div class="mock-nav">
              <el-icon @click="changePanel(0)" class="nav-action"
                ><ArrowLeft
              /></el-icon>
              <span class="nav-title"
                >第 {{ selectNumber + 1 }}/{{ domains.length || 1 }} 题</span
              >
              <el-icon @click="changePanel(1)" class="nav-action"
                ><ArrowRight
              /></el-icon>
            </div>

            <div
              class="screen-scrollable"
              v-if="domains.length > 0 && domains[selectNumber]"
            >
              <div class="choice-preview-title">
                {{ domains[selectNumber].value || "题目描述文字..." }}
              </div>

              <div class="choice-preview-options">
                <div
                  v-for="(opt, oIndex) in domains[selectNumber].options"
                  :key="oIndex"
                  :class="[
                    'mock-option-box',
                    { active: domains[selectNumber].rightAnswer === opt.one },
                  ]"
                >
                  <span class="opt-prefix">{{
                    String.fromCharCode(65 + oIndex)
                  }}</span>
                  <span class="opt-txt">{{ opt.one || "选项内容..." }}</span>
                </div>
              </div>
            </div>
            <div class="screen-empty" v-else>暂未添加选择题数据</div>

            <div class="screen-footer">
              <button class="mock-submit-btn">确认提交</button>
            </div>
          </div>

          <!-- AR题真机预览 -->
          <div class="phone-screen ar-mock-screen" v-else>
            <div class="mock-nav">
              <el-icon><ArrowLeft /></el-icon>
              <span class="nav-title">AR 扫描互动</span>
              <el-icon><QuestionFilled /></el-icon>
            </div>

            <div class="ar-viewfinder">
              <div class="scan-grid"></div>
              <span class="scan-tip">{{
                form.arQuestion || "请对准目标物体进行扫描识别"
              }}</span>
              <div class="target-box" v-if="form.arImageRecognition">
                <img :src="form.arImageRecognition" alt="AR Target" />
              </div>
            </div>

            <div class="screen-footer">
              <button class="mock-submit-btn">开始 AR 识别</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from "vue";
import {
  Plus,
  ArrowLeft,
  QuestionFilled,
  ArrowRight,
  Delete,
} from "@element-plus/icons-vue";
import {
  ElMessage,
  ElNotification,
  FormRules,
  UploadProps,
} from "element-plus";
type ImageFormKey =
  | "levelCover"
  | "arImageRecognition"
  | "arImageContent"
  | "arImageBack";
const validateNotEmpty = (rule: any, value: string, callback: any) => {
  if (!value || value.toString().trim() === "") {
    callback(new Error(rule.message));
  } else {
    callback();
  }
};

export default defineComponent({
  name: "LevelDesignForm",
  components: { Plus, ArrowLeft, QuestionFilled, ArrowRight, Delete },
  props: ["dataForm"],
  data(): any {
    return {
      form: {
        difficulty: 3,
        levelTitle: "",
        levelCover: "",
        arQuestion: "",
        arImageRecognition: "",
        arImageContent: "",
        arImageBack: "",
        levelContent: "",
        levelDesc: "",
        selectRole: "",
        roleTip: "",
        region: "填空题",
        questions: "",
      },
      selectRole2: [],
      fileList: [],
      fileList2: [],
      fileList3: [],
      selectNumber: 0,
      domains: [],
      roleOptions: [],
      rules: reactive<FormRules>({
        levelTitle: [
          {
            required: true,
            message: "关卡标题不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        region: [
          {
            required: true,
            message: "请选择题目类型",
            trigger: "change",
            validator: validateNotEmpty,
          },
        ],
        levelContent: [
          {
            required: true,
            message: "关卡谜题正文不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        levelDesc: [
          {
            required: true,
            message: "关卡答案不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
      }),
    };
  },
  computed: {
    difficultyText(): string {
      const map: Record<number, string> = {
        1: "简单新手",
        2: "初窥门径",
        3: "适中挑战",
        4: "逻辑烧脑",
        5: "硬核推理",
      };
      return map[this.form.difficulty] || "未知难度";
    },
    allowUpload(): boolean {
      return Boolean(this.form.levelCover);
    },
    allowUpload2(): boolean {
      return Boolean(this.form.arImageRecognition);
    },
    allowUpload3(): boolean {
      return Boolean(this.form.arImageContent);
    },
    allowUpload4(): boolean {
      return Boolean(this.form.arImageBack);
    },
    UpdateApi(): string {
      return process.env.VUE_APP_Update_API || "";
    },
  },
  watch: {
    domains: {
      handler(newVal) {
        if (!newVal) return;
        const validList = newVal.filter(
          (item: any) =>
            item.options &&
            item.options.length >= 2 &&
            item.rightAnswer &&
            item.rightAnswer !== "test123456"
        );
        this.form.questions = JSON.stringify(validList);
      },
      immediate: true,
      deep: true,
    },
    dataForm: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.updateForm(newVal);
        }
      },
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.$store
        .dispatch("game/getRoles", { gameId: this.$route.params.id })
        .then((res: any) => {
          if (Array.isArray(res)) {
            this.roleOptions = res
              .filter((item: any) => item.isKeyRole === 1) // 只保留 isKeyRole=1
              .map((item: any) => ({
                value: item.roleId,
                label: item.roleName,
              }));
          }
        })
        .catch(() => {});
    }
  },
  methods: {
    updateForm(dataForm: any) {
      this.form.difficulty = dataForm.difficulty || 3;
      this.form.levelTitle = dataForm.levelTitle || "";
      this.form.levelCover = dataForm.levelCover || "";
      this.form.arQuestion = dataForm.arQuestion || "";
      this.form.arImageBack = dataForm.arImageBack || "";
      this.form.arImageContent = dataForm.arImageContent || "";
      this.form.arImageRecognition = dataForm.arImageRecognition || "";
      this.form.levelContent = dataForm.levelContent || "";
      this.form.levelDesc = dataForm.levelDesc || "";
      this.form.region = dataForm.region || "填空题";
      this.form.questions = dataForm.questions || "";
      this.form.roleTip = dataForm.roleTip || "";

      if (dataForm.selectRole) {
        this.selectRole2 = dataForm.selectRole.split(",");
      } else {
        this.selectRole2 = [];
      }

      if (dataForm.questions) {
        try {
          this.domains = JSON.parse(dataForm.questions);
        } catch (e) {
          this.domains = [];
        }
      }
    },
    beforeAvatarUpload(file: File): boolean {
      const isAllowedFormat =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/webp";
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isAllowedFormat) {
        ElNotification.warning({
          message: "仅支持 JPG/PNG/WEBP 格式图片",
          offset: 100,
        });
        return false;
      }
      if (!isLt5M) {
        ElNotification.warning({
          message: "图片大小不可超过 5MB",
          offset: 100,
        });
        return false;
      }
      return true;
    },
    handleAvatarSuccess(res: any) {
      if (res?.data?.returnFileUrl)
        this.form.levelCover = res.data.returnFileUrl;
    },
    handleAvatarSuccess2(res: any) {
      if (res?.data?.returnFileUrl)
        this.form.arImageRecognition = res.data.returnFileUrl;
    },
    handleAvatarSuccess3(res: any) {
      if (res?.data?.returnFileUrl)
        this.form.arImageContent = res.data.returnFileUrl;
    },
    handleAvatarSuccess4(res: any) {
      if (res?.data?.returnFileUrl)
        this.form.arImageBack = res.data.returnFileUrl;
    },
    async clearImage(fieldKey: ImageFormKey) {
      const fileName = this.form[fieldKey];
      if (!fileName) return;

      try {
        await this.$store.dispatch("user/delFile", { fileName });

        this.form[fieldKey] = "";
        ElMessage.success("图片已删除");
      } catch (error) {
        console.error(`删除图片 ${fieldKey} 失败:`, error);
        ElMessage.error("删除图片失败");
      }
    },
    removeDomain(item: any) {
      const idx = this.domains.indexOf(item);
      if (idx !== -1) {
        this.domains.splice(idx, 1);
        if (this.selectNumber >= this.domains.length && this.selectNumber > 0) {
          this.selectNumber = this.domains.length - 1;
        }
      }
    },
    deleteOption(domain: any, oIndex: number) {
      if (domain.options && domain.options.length > 0) {
        domain.options.splice(oIndex, 1);
      }
    },
    addDomain() {
      if (this.domains.length < 4) {
        this.domains.push({
          key: Date.now(),
          value: "",
          rightAnswer: "",
          options: [
            { one: "", id: Date.now() + 1 },
            { one: "", id: Date.now() + 2 },
          ],
        });
        this.selectNumber = this.domains.length - 1;
      }
    },
    addOption(domain: any) {
      if (!domain.options) domain.options = [];
      if (domain.options.length < 4) {
        domain.options.push({
          one: "",
          id: Date.now() + Math.random(),
        });
      }
    },
    changePanel(direction: number) {
      if (direction === 1 && this.selectNumber < this.domains.length - 1) {
        this.selectNumber++;
      } else if (direction === 0 && this.selectNumber > 0) {
        this.selectNumber--;
      }
    },
    resetForm() {
      this.domains = [];
      this.selectNumber = 0;
    },
    valueChange(val: string[]) {
      this.form.selectRole = val.join(",");
    },
  },
});
</script>

<style lang="less" scoped>
@primary-color: #5d5fef;
@primary-light: #f0f2ff;
@text-main: #1e293b;
@text-sub: #64748b;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;
@danger-color: #ef4444;

.form2-container {
  width: 100%;
}

.section-header {
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid @border-color;
  display: flex;
  align-items: baseline;
  gap: 12px;

  .section-title {
    font-size: 17px;
    font-weight: 700;
    color: @text-main;
    margin: 0;
  }

  .section-tip {
    font-size: 13px;
    color: @text-muted;
  }
}

.editor-layout {
  display: flex;
  gap: 40px;
  align-items: flex-start;

  @media (max-width: 992px) {
    flex-direction: column;
    gap: 32px;
  }
}

.form-area {
  flex: 1;
  max-width: 600px;
  width: 100%;

  .custom-form {
    :deep(.el-form-item) {
      margin-bottom: 22px;

      .el-form-item__label {
        font-size: 13.5px;
        font-weight: 600;
        color: @text-main;
        padding-bottom: 6px;
      }
    }

    :deep(.el-input__wrapper),
    :deep(.el-textarea__inner) {
      border-radius: 8px;
      box-shadow: 0 0 0 1px @border-color inset;
      transition: all 0.2s ease;

      &:hover {
        box-shadow: 0 0 0 1px #cbd5e1 inset;
      }

      &.is-focus,
      &:focus {
        box-shadow: 0 0 0 1px @primary-color inset !important;
      }
    }
  }
}

.rate-box {
  display: flex;
  align-items: center;
  gap: 14px;

  .rate-tip {
    font-size: 13px;
    font-weight: 600;
    color: @primary-color;
  }
}

.role-alert {
  margin: 10px 0 12px;
  border-radius: 8px;
}

.type-radio-group {
  :deep(.el-radio-button__inner) {
    padding: 9px 24px;
    border-radius: 8px;
    font-weight: 600;
  }
}

.question-branch {
  margin-top: 10px;
}

// 单图卡片上传器
.single-uploader-card {
  .uploader-box {
    :deep(.el-upload) {
      width: 100%;
      display: block;
      cursor: pointer;
    }
  }

  .img-preview-box {
    position: relative;
    width: 100%;
    height: 160px;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid @border-color;
    background: #f8fafc;

    .img-content {
      width: 100%;
      height: 100%;
      display: block;
    }

    .hover-mask {
      position: absolute;
      inset: 0;
      background: rgba(15, 23, 42, 0.55);
      backdrop-filter: blur(2px);
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0;
      transition: opacity 0.25s ease;

      .del-btn {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        background: #ffffff;
        color: @danger-color;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
        transition: transform 0.2s;

        &:hover {
          transform: scale(1.12);
        }
      }
    }

    &:hover .hover-mask {
      opacity: 1;
    }
  }

  .upload-trigger {
    width: 100%;
    height: 120px;
    border: 1.5px dashed #cbd5e1;
    border-radius: 10px;
    background: #f8fafc;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 6px;
    transition: all 0.2s ease;

    .icon {
      font-size: 20px;
      color: @text-sub;
    }

    .text {
      font-size: 13px;
      font-weight: 500;
      color: @text-main;
    }

    &:hover {
      border-color: @primary-color;
      background: @primary-light;

      .icon,
      .text {
        color: @primary-color;
      }
    }
  }
}

// 选择题题目卡片
.choice-card {
  background: #f8fafc;
  border: 1px solid @border-color;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;

  .choice-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .title {
      font-size: 14px;
      font-weight: 700;
      color: @text-main;
    }
  }

  .options-container {
    .opt-label {
      font-size: 12px;
      color: @text-muted;
      margin-bottom: 8px;
      display: block;
    }

    .opt-radio-group {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;

      .option-row {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;

        .opt-radio {
          margin-right: 0;
        }

        .opt-input {
          flex: 1;
        }

        .opt-del-btn {
          padding: 4px;
          color: @text-muted;

          &:hover {
            color: @danger-color;
          }
        }
      }
    }

    .opt-footer-actions {
      margin-top: 12px;
    }
  }
}

.choice-actions {
  display: flex;
  gap: 12px;
  margin-top: 10px;
}

// AR 双列上传
.ar-uploaders-row {
  display: flex;
  gap: 16px;

  .ar-upload-item {
    flex: 1;
  }
}

// 右侧真机拟物化视口
.preview-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;

  .preview-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    color: @text-sub;
    margin-bottom: 14px;

    .badge-dot {
      width: 8px;
      height: 8px;
      background: #10b981;
      border-radius: 50%;
      box-shadow: 0 0 6px rgba(16, 185, 129, 0.6);
    }
  }
}

.mockup-phone {
  width: 290px;
  height: 540px;
  background: #ffffff;
  border-radius: 36px;
  border: 10px solid #0f172a;
  box-shadow: 0 16px 36px -6px rgba(15, 23, 42, 0.16);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .phone-top-bar {
    width: 100%;
    height: 20px;
    display: flex;
    justify-content: center;
    background: #ffffff;
    z-index: 10;

    .notch {
      width: 76px;
      height: 12px;
      background: #0f172a;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
    }
  }

  .phone-screen {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #f8fafc;
  }

  .mock-nav {
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px;
    border-bottom: 1px solid @border-color;
    background: #ffffff;
    font-size: 14px;
    color: @text-main;

    .nav-title {
      font-weight: 700;
      font-size: 13px;
    }

    .nav-action {
      cursor: pointer;
      color: @primary-color;
    }
  }

  .screen-scrollable {
    flex: 1;
    padding: 14px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .mock-sub-row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .diff-tag {
      font-size: 11px;
      color: @text-muted;
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .recall-btn {
      font-size: 11px;
      color: @primary-color;
      background: @primary-light;
      padding: 2px 8px;
      border-radius: 4px;
    }
  }

  .mock-body-text {
    font-size: 12.5px;
    color: @text-main;
    line-height: 1.6;
    white-space: pre-wrap;
  }

  .mock-clue-card {
    background: #ffffff;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid @border-color;
    display: flex;
    flex-direction: column;
    gap: 6px;

    .clue-tag {
      font-size: 11px;
      color: @text-muted;
      font-weight: 600;
    }

    .clue-img {
      width: 100%;
      height: 90px;
      border-radius: 6px;
    }
  }

  // 选择题视口样式
  .choice-preview-title {
    font-size: 13px;
    font-weight: 700;
    color: @text-main;
    line-height: 1.5;
  }

  .choice-preview-options {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .mock-option-box {
      display: flex;
      align-items: center;
      gap: 10px;
      background: #ffffff;
      border: 1px solid @border-color;
      padding: 8px 12px;
      border-radius: 8px;
      font-size: 12px;
      color: @text-sub;
      transition: all 0.2s ease;

      .opt-prefix {
        font-weight: 700;
        color: @text-muted;
      }

      &.active {
        border-color: @primary-color;
        background: @primary-light;
        color: @primary-color;

        .opt-prefix {
          color: @primary-color;
        }
      }
    }
  }

  .screen-empty {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: @text-muted;
  }

  // AR 视口
  .ar-mock-screen {
    .ar-viewfinder {
      flex: 1;
      margin: 14px;
      border-radius: 12px;
      background: #0f172a;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: 1.5px dashed rgba(255, 255, 255, 0.3);

      .scan-tip {
        color: #ffffff;
        font-size: 11px;
        z-index: 2;
        padding: 0 16px;
        text-align: center;
      }

      .target-box {
        margin-top: 10px;
        width: 100px;
        height: 100px;
        border: 2px solid @primary-color;
        border-radius: 8px;
        overflow: hidden;
        z-index: 2;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }

  .screen-footer {
    padding: 10px 14px 14px;
    background: #ffffff;
    border-top: 1px solid @border-color;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .mock-input-mock {
      height: 32px;
      background: #f1f5f9;
      border-radius: 6px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: @text-muted;
    }

    .mock-submit-btn {
      width: 100%;
      height: 34px;
      border-radius: 17px;
      border: none;
      background: @primary-color;
      color: #ffffff;
      font-size: 12px;
      font-weight: 600;
      cursor: default;
      box-shadow: 0 2px 6px rgba(93, 95, 239, 0.25);
    }
  }
}
</style>
